import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/asideimg/home.png'


const _withScopeId = n => (_pushScopeId("data-v-179864ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "aside_list" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "iconImg",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode("首页")
const _hoisted_4 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu_item_group = _resolveComponent("el-menu-item-group")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu = _resolveComponent("el-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_menu, {
      "text-color": "#C2C6CD",
      "active-text-color": "#fff",
      "default-active": "2",
      class: "el-menu-vertical-demo",
      "unique-opened": "true",
      router: "true",
      collapse: _ctx.collapseState,
      onOpen: _ctx.handleOpen
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_menu_item, {
          index: "/home",
          style: {"padding-left":"20px !important"}
        }, {
          title: _withCtx(() => [
            _hoisted_3
          ]),
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabRoutes(), (item) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: item.path
          }, [
            (item.name !== 'Home')
              ? (_openBlock(), _createBlock(_component_el_sub_menu, {
                  key: 0,
                  index: item.path
                }, {
                  title: _withCtx(() => [
                    _createElementVNode("img", {
                      class: "iconImg",
                      src: item.resourceIoc ? require(`@/assets/asideimg/${item.resourceIoc}.png`) : '',
                      alt: ""
                    }, null, 8, _hoisted_4),
                    _createElementVNode("span", null, _toDisplayString(item.name), 1)
                  ]),
                  default: _withCtx(() => [
                    (item.children)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (item.children)
                            ? (_openBlock(), _createBlock(_component_el_menu_item_group, { key: 0 }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (item2) => {
                                    return (_openBlock(), _createBlock(_component_el_menu_item, {
                                      key: item2.id,
                                      class: _normalizeClass({
                  'is-active': item2.path == _ctx.route.path && _ctx.collapseState == false,
                  activenone: item2.path !== _ctx.route.path && _ctx.collapseState == false,
                }),
                                      index: item2.path,
                                      onClick: _ctx.myMenu,
                                      ref_for: true,
                                      ref: "menuItem"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", {
                                          class: _normalizeClass({ isAcitve: !_ctx.collapseState })
                                        }, _toDisplayString(item2.name), 3)
                                      ]),
                                      _: 2
                                    }, 1032, ["class", "index", "onClick"]))
                                  }), 128))
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["index"]))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ]),
      _: 1
    }, 8, ["collapse", "onOpen"])
  ]))
}